import { useMemo } from 'react';
import { StepsType } from 'core/stepper/Stepper.types';
import { useGetSteps } from 'components/Stepper/useGetSteps';
import useWithdrawalChangePlan from 'datasource/ChangeWithdrawal/useWithdrawalChangePlan';
import ChangeWithdrawalPlanSummaryPage from '../pages/ChangeWithdrawalPlanSummaryPage';
import ChangeWithdrawalPlanBankInfoPage from '../pages/ChangeWithdrawalPlanBankInfoPage';

export const stepsKeys = {
    WithDrawalPlan: 'withdrawal-plan',
    BankInformation: 'bank-information',
    Child1: 'child-1',
    Child2: 'child-2',
};

export const process = {
    main: 'parent',
    summary: 'summary',
    bankDetails: 'bankDetails',
};

const useChangeWithdrawalFlow = () => {
    const changeWithdrawalFlow: StepsType = useMemo(() => ({
        [stepsKeys.WithDrawalPlan]: {
            datasource: useWithdrawalChangePlan,
            process: process.main,
            stepperTitle: '3b.withdrawalPlan.ChangeWithdrawalSummary.stepperTitle',
            contentClassName: 'change-withdrawal-plan',
            component: ChangeWithdrawalPlanSummaryPage,
            url: 'withdrawal-plan',
            next: [
                {
                    target: stepsKeys.BankInformation,
                    condition: () => true,
                },
            ],
            isBegin: true,
        },
        [stepsKeys.BankInformation]: {
            datasource: useWithdrawalChangePlan,
            process: process.main,
            stepperTitle: '3b.withdrawalPlan.ChangeWithdrawalBankInfo.stepperTitle',
            contentTitle: '3b.withdrawalPlan.ChangeWithdrawalBankInfo.title',
            contentClassName: 'change-withdrawal-plan',
            component: ChangeWithdrawalPlanBankInfoPage,
            url: 'bank-information',
            prev: [
                {
                    target: stepsKeys.WithDrawalPlan,
                    condition: () => true,
                },
            ],
            isEnd: true,
        },
    }), []);

    const { stepsBasedOnState } = useGetSteps({ flow: changeWithdrawalFlow, initialStep: stepsKeys.WithDrawalPlan });

    return { stepsBasedOnState };
};

export default useChangeWithdrawalFlow;
